module.exports = __webpack_public_path__ + "img/wtb6.0a8beda3.png";